module.exports = __webpack_public_path__ + "static/img/am.06669df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/media/am.jpg
// module id = +7Sq
// module chunks = 1